import AdminStatePanel from "../../layout/AdminStatePanel";
import { formatDateTime } from "../../users/adminUserFormatters";
import { getWeatherSourceCategoryLabel } from "../../../../../constants/colombiaWeatherSourceMetadata.js";
import WeatherFreshnessLabel from "./WeatherFreshnessLabel";
import WeatherHealthBadge from "./WeatherHealthBadge";

function formatTimestamp(value) {
  if (!value) {
    return "—";
  }

  return formatDateTime(value);
}

const WeatherSourceHealthTable = ({
  sources,
  selectedSourceKey,
  onSelectSource,
  canManage,
}) => {
  if (!sources.length) {
    return (
      <AdminStatePanel
        variant="empty"
        message="No sources match the current filters. Try adjusting filters or include disabled sources."
      />
    );
  }

  return (
    <div className="admin-data-health-table-wrap">
      <table className="admin-data-health-table">
        <thead>
          <tr>
            <th scope="col">Source</th>
            <th scope="col">Role</th>
            <th scope="col">Provider</th>
            <th scope="col">Type</th>
            <th scope="col">Official</th>
            <th scope="col">Live / archive</th>
            <th scope="col">Status</th>
            <th scope="col">Last observed</th>
            <th scope="col">Last success</th>
            <th scope="col">Freshness</th>
            <th scope="col">Fallback</th>
            <th scope="col">Latest run</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {sources.map((source) => {
            const isSelected = selectedSourceKey === source.sourceKey;

            return (
              <tr
                key={source.sourceKey}
                className={isSelected ? "admin-data-health-table__row--selected" : undefined}
              >
                <td>
                  <button
                    type="button"
                    className="admin-data-health-table__source-btn"
                    onClick={() => onSelectSource(source.sourceKey)}
                  >
                    <strong>{source.sourceName}</strong>
                    <span className="admin-data-health-table__source-key">{source.sourceKey}</span>
                  </button>
                </td>
                <td>{source.sourceCategoryLabel || getWeatherSourceCategoryLabel(source.sourceKey) || "—"}</td>
                <td>{source.providerName || "—"}</td>
                <td>{source.sourceType?.replace(/_/g, " ") || "—"}</td>
                <td>{source.isOfficial ? "Yes" : "No"}</td>
                <td>
                  {source.isHistorical ? "Archive" : source.isLive ? "Live" : "—"}
                </td>
                <td>
                  <WeatherHealthBadge status={source.healthStatus} />
                </td>
                <td>{formatTimestamp(source.lastObservedDataAt)}</td>
                <td>{formatTimestamp(source.lastSuccessAt)}</td>
                <td>
                  <WeatherFreshnessLabel
                    freshnessMinutes={source.freshnessMinutes}
                    expectedRefreshMinutes={source.expectedRefreshMinutes}
                    healthStatus={source.healthStatus}
                  />
                </td>
                <td>
                  {source.fallback?.fallbackSourceKey ? (
                    <span
                      className={
                        source.fallback.fallbackActive
                          ? "weather-fallback-label weather-fallback-label--active"
                          : "weather-fallback-label"
                      }
                    >
                      {source.fallback.fallbackActive ? "Active" : "Standby"}
                      {source.fallback.reason ? ` — ${source.fallback.reason}` : ""}
                    </span>
                  ) : (
                    "—"
                  )}
                </td>
                <td>
                  {source.latestRun ? (
                    <>
                      <div>{source.latestRun.runType}</div>
                      <div className="admin-data-health-table__meta">
                        {source.latestRun.status} · {formatTimestamp(source.latestRun.startedAt)}
                      </div>
                    </>
                  ) : (
                    "No runs"
                  )}
                </td>
                <td>
                  <button
                    type="button"
                    className="admin-dashboard__action-btn admin-dashboard__action-btn--small"
                    onClick={() => onSelectSource(source.sourceKey)}
                  >
                    Details
                  </button>
                  {!canManage ? (
                    <span className="admin-data-health-table__meta">View only</span>
                  ) : null}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default WeatherSourceHealthTable;
